let triggers;

const sizeGuide = () => {
  const trigger = document.querySelectorAll('.js-size-guide-trigger')
  const popUp = document.querySelector('.js-size-guide')
  const close = document.querySelector('.js-size-guide-close')
  const overlay = document.querySelector('.js-size-guide-overlay')

  trigger.forEach(el => {
    el.addEventListener('click', () => {
      popUp.classList.add('show')
      overlay.classList.add('show')
    })
  })

  close.addEventListener('click', () => {
    popUp.classList.remove('show')
    overlay.classList.remove('show')
  })
}

const refreshContent = (link) => {
  let section_ids = []
  let sections = document.querySelectorAll('.js-smp-reload')
  
  sections.forEach(section => {
    let sectionId = section.getAttribute('id').replace('shopify-section-','')
    section_ids.push(sectionId)
  })

  Promise.all(section_ids.map((sectionId) => {
    return new Promise((resolve) => {
      let newUrl = link + `?section_id=` + sectionId
      window
        .fetch(newUrl)
        .then()
        .then((_) => _.text())
        .then((html) => {
          let sectionElement = $('#shopify-section-' + sectionId)
          sectionElement.replaceWith(html)
        })
        .then((_) => {
          resolve(true)
        })
        .catch((err) => {
          resolve(true)
          console.log(err)
        })
        .then((_) => {
          sizeGuide()
        })
      })
  }))
}

sizeGuide()